import { makeStyles } from 'tss-react/mui';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useEffect, useState } from 'react';
import { getUser } from '../../helpers/token';
import ErrorPage from '../General/ErrorPage';
import Head from '../Header/Head';
import DashboardMenu from './DashboardMenu';
import HiveAuthorityCheck from './HiveAuthorityCheck';

const useStyles = makeStyles()(theme => ({
  root: {
    background: theme.palette.background.default,
  },
}));

const DashboardPage = props => {
  const { classes } = useStyles();

  const [user, setUser] = useState(null);

  const isMobileView = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    setUser(getUser());
  }, []);

  const {
    open,
    bottomNav,
    label,
    showForAnyone,
    shorttitle,
    description,
    ogImage,
    justTitle,
  } = props;

  if (showForAnyone || user !== null) {
    return (
      <>
        <Head
          justTitle={
            justTitle ||
            `${
              shorttitle || `${label.charAt(0).toUpperCase() + label.slice(1)}`
            } – TravelFeed Dashboard`
          }
          description={description}
          noIndex={!showForAnyone}
          includeMapbox={props.includeMapbox}
          image={ogImage}
        />
        <DashboardMenu
          unreadCountOffset={props.unreadCountOffset}
          activePage={props.activePage}
          isMobileView={isMobileView}
          bottomNav={bottomNav}
          active={label}
          content={
            <div className={'safebottom ' + classes.root}>
              {(!user && !showForAnyone && (
                <ErrorPage statusCode="logged_out" />
              )) || (
                <>
                  <HiveAuthorityCheck isTopPadding={label === 'publish'} />
                  {props.content}
                </>
              )}
            </div>
          }
          open={open}
        />
      </>
    );
  }
  return (
    <>
      <Head
        justTitle={`${
          shorttitle || `${label.charAt(0).toUpperCase() + label.slice(1)}`
        } – TravelFeed Dashboard`}
        noIndex
      />
      <DashboardMenu
        unreadCountOffset={props.unreadCountOffset}
        isMobileView={isMobileView}
        bottomNav={bottomNav}
        active={label}
        content={<></>}
        open={open}
      />
    </>
  );
};

export default DashboardPage;
